import { render, staticRenderFns } from "./HelpDetail.vue?vue&type=template&id=350065fe&scoped=true&"
import script from "./HelpDetail.vue?vue&type=script&lang=js&"
export * from "./HelpDetail.vue?vue&type=script&lang=js&"
import style0 from "./HelpDetail.vue?vue&type=style&index=0&id=350065fe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350065fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('350065fe', component.options)
    } else {
      api.reload('350065fe', component.options)
    }
    module.hot.accept("./HelpDetail.vue?vue&type=template&id=350065fe&scoped=true&", function () {
      api.rerender('350065fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/HelpDetail.vue"
export default component.exports